import { useSearchParams } from 'react-router';
import useValidateResetLinkQuery from './queries/useValidateResetLinkQuery';
import { ottParamName } from './ResetPassword.constants';

const useResetLinkValidation = () => {
  const [searchParams] = useSearchParams();
  const ott = searchParams.get(ottParamName) ?? undefined;
  return useValidateResetLinkQuery({ ott });
};

export default useResetLinkValidation;
